<app-breadcrumb *ngIf="!disableBreadcrumb" [master]="'Rejestracje'" [parentName]="'Rejestracje'" [name]="'Lista'"></app-breadcrumb>
<app-breadcrumb *ngIf="disableBreadcrumb && customBreadcrumb" [master]="'Administracja'" [parentName]="'Hiperio'" [name]="'Dostępy testowe'"></app-breadcrumb>

<div class="registration-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="registration-list-filters">
    <ng-container *ngIf="!disableFilters">
      <app-dict-ofwcas
        *ngIf="ofwcaId === null" [multiple]="false"
        label="OFWCA" class="registration-list-filter"
        [(ngModel)]="initialFilters.ofwca"
        name="ofwca"
      ></app-dict-ofwcas>

      <app-dict-all-contracts
        *ngIf="contractId === null" [multiple]="false"
        label="Umowa" class="registration-list-filter"
        [(ngModel)]="initialFilters.contract"
        name="contract"
      ></app-dict-all-contracts>

      <app-dict-insurance-companies
        *ngIf="insuranceCompanyId === null" (selectedInsuranceCompanies)="selectedInsuranceCompanies = $event"
        [multiple]="true" label="TU" class="registration-list-filter"
        [(ngModel)]="initialFilters.in$insuranceCompany"
        name="in$insuranceCompany"
      ></app-dict-insurance-companies>

      <app-dict
        [multiple]="false" [dictType]="'sales_' + (selectedInsuranceCompanies ? selectedInsuranceCompanies[0]?.key : '')"
        [label]="'Nazwa profilu'" class="registration-list-filter"
        matTooltip="Najpierw wybierz TU"
        matTooltipPosition="left"
        [matTooltipDisabled]="!!selectedInsuranceCompanies"
        [(ngModel)]="initialFilters.salesProfileType" name="salesProfileType"
      ></app-dict>

      <app-dict
        *ngIf="!onlyChronie" [multiple]="false"
        label="Rodzaj TU" class="registration-list-filter"
        dictType="insurance_type"
        [(ngModel)]="initialFilters.insuranceCompanyType" name="insuranceCompanyType"
      ></app-dict>

      <app-dict
        [multiple]="true"
        [onlyKeys]="statusKeys ? statusKeys : undefined"
        label="Status" class="registration-list-filter"
        dictType="registration_status"
        [(ngModel)]="initialFilters.in$status" name="in$status"
      ></app-dict>

      <app-dict
        [multiple]="false" [dictType]="'sales_profile_status'"
        [label]="'Status profilu'" class="registration-list-filter"
        [(ngModel)]="initialFilters.salesProfileStatus" name="salesProfileStatus"
      ></app-dict>

      <mat-form-field *ngIf="statements === null && !onlyChronie" appearance="standard" class="registration-list-filter">
        <mat-label>Oświadczenia komplet</mat-label>
        <mat-select [(ngModel)]="initialFilters.statements" name="statements">
          <mat-option [value]="null">Wszyscy</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <app-dict
        *ngIf="!onlyChronie" [multiple]="false"
        label="Firma" class="registration-list-filter"
        dictType="company"
        [(ngModel)]="initialFilters.company" name="company"
      ></app-dict>

      <app-dict-partners
        [multiple]="false" label="Partner"
        class="registration-list-filter"
        [(ngModel)]="initialFilters.partner" name="partner"
      ></app-dict-partners>

      <app-dict-regionals
        [multiple]="true" label="Regionalny (majątek)"
        class="registration-list-filter"
        [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
      ></app-dict-regionals>

      <app-dict-regionals
        [multiple]="true" label="Regionalny (życie)"
        class="registration-list-filter"
        [(ngModel)]="initialFilters.lifeRegional" name="lifeRegional"
      ></app-dict-regionals>

      <app-dict
        *ngIf="!onlyChronie" label="Podwójna rejestracja"
        class="registration-list-filter"
        dictType="double_registration"
        [(ngModel)]="initialFilters.doubleRegistration" name="doubleRegistration"
      ></app-dict>

      <app-dict
        *ngIf="!onlyChronie" label="Jaki egzamin potrzebny"
        class="registration-list-filter"
        dictType="exam_type"
        [(ngModel)]="initialFilters.missingExam" name="missingExam"
      ></app-dict>

      <mat-form-field appearance="standard" class="registration-list-filter" *ngIf="activeKrk === null && !onlyChronie">
        <mat-label>Aktywne KRK</mat-label>
        <mat-select
          [(ngModel)]="initialFilters.activeKrk" name="activeKrk"
        >
          <mat-option [value]="null">Wszyscy</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="standard" class="registration-list-filter" *ngIf="!onlyChronie">
        <mat-label>Zaświadczenie 100p</mat-label>
        <mat-select
          [(ngModel)]="initialFilters.passedExam100p" name="passedExam100p"
        >
          <mat-option [value]="null">Wszyscy</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field *ngIf="hasDiploma === null && !onlyChronie" appearance="standard" class="registration-list-filter">
        <mat-label>Dyplom</mat-label>
        <mat-select
          [(ngModel)]="initialFilters.hasDiploma" name="hasDiploma"
        >
          <mat-option [value]="null">Wszyscy</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field *ngIf="agreedToDeregister === null && displayedColumns.includes('agreedToDeregister') && !onlyChronie"
                      appearance="standard" class="registration-list-filter">
        <mat-label>Zgoda na wyrejestrowanie</mat-label>
        <mat-select
          ngModel name="agreedToDeregister"
        >
          <mat-option [value]="null">Wszyscy</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <app-dict
        class="registration-list-filter" [label]="'Tagi partnera'"
        [dictType]="'partner_tags'"
        [required]="false" [multiple]="true"
        [(ngModel)]="initialFilters.partnerTags" name="partnerTags"
      ></app-dict>

      <app-dict
        class="registration-list-filter" [label]="'Status upoważnienia'"
        [dictType]="'authorization_status'"
        [required]="false" [multiple]="false"
        [(ngModel)]="initialFilters.authorizationStatus" name="authorizationStatus"
      ></app-dict>

      <app-datepicker
        class="registration-list-filter"
        label="Data wygenerowania upoważnienia od"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.gte$authorizationGeneratedAt" name="gte$authorizationGeneratedAt"
      ></app-datepicker>

      <app-datepicker
        class="registration-list-filter"
        label="Data wygenerowania upoważnienia do"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.lte$authorizationGeneratedAt" name="lte$authorizationGeneratedAt"
      ></app-datepicker>

      <app-datepicker
        class="registration-list-filter"
        label="Data dodania wniosku o rejestrację od"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
      ></app-datepicker>

      <app-datepicker
        class="registration-list-filter"
        label="Data dodania wniosku o rejestrację do"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
      ></app-datepicker>

      <mat-form-field appearance="standard" class="registration-list-filter" *ngIf="!revokedChronieAccess && !newChronieAccess">
        <mat-label>Dostęp chronie.pl</mat-label>
        <mat-select [(ngModel)]="initialFilters.chronieAccess" name="chronieAccess">
          <mat-option [value]="null">Wszyscy</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="registration-list-filter" *ngIf="onlyChronie">
        <mat-label>Login chronie.pl</mat-label>
        <input matInput placeholder="adres@asf24.pl" name="chronieLogin" [(ngModel)]="initialFilters.chronieLogin">
      </mat-form-field>

      <mat-form-field class="registration-list-filter" *ngIf="onlyChronie">
        <mat-label>Kod zniżkowy</mat-label>
        <input matInput placeholder="000001" name="chronieDiscountCode" [(ngModel)]="initialFilters.chronieDiscountCode">
      </mat-form-field>

      <mat-form-field appearance="standard" class="registration-list-filter">
        <mat-label>Blokada sprzedaży - Wysłane do TU</mat-label>
        <mat-select [(ngModel)]="initialFilters.sentToBlock" name="sentToBlock">
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="standard" class="registration-list-filter">
        <mat-label>Blokada sprzedaży - Zablokowane</mat-label>
        <mat-select [(ngModel)]="initialFilters.blocked" name="blocked">
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="standard" class="registration-list-filter">
        <mat-label>Zgoda na rejestrację w PZU</mat-label>
        <mat-select [(ngModel)]="initialFilters.agreedToRegisterInPzu" name="agreedToRegisterInPzu">
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="registration-list-filter">
        <mat-label>Numer RAU</mat-label>
        <input matInput placeholder="Numer RAU" name="rauNumber" [(ngModel)]="initialFilters.rauNumber">
      </mat-form-field>

      <app-dict-deregistration-packs
        class="registration-list-filter" [label]="'Paczka wyrejestrowań'"
        [required]="false" [multiple]="false"
        [(ngModel)]="initialFilters.deregistrationPack" name="deregistrationPack"
      ></app-dict-deregistration-packs>

      <app-dict
        class="registration-list-filter"
        [multiple]="false" [dictType]="'address_state'"
        [label]="'Województwo placówki OFWCA'"
        [(ngModel)]="initialFilters.facilityStateOfwca" name="facilityStateOfwca"
      ></app-dict>
      <mat-form-field appearance="standard" class="registration-list-filter">
        <mat-label>Wysłano do weryfikacji PZU</mat-label>
        <mat-select [(ngModel)]="initialFilters.sentToPzuForVerification" name="sentToPzuForVerification">
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="standard" class="registration-list-filter">
        <mat-label>Dodatkowa weryfikacja PZU</mat-label>
        <mat-select [(ngModel)]="initialFilters.pzuVerificationSupplement" name="pzuVerificationSupplement">
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="standard" class="registration-list-filter">
        <mat-label>Dostarczony wniosek o wykreślenie </mat-label>
        <mat-select [(ngModel)]="initialFilters.registrationIdTypeSent" name="registrationIdTypeSent">
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <app-datepicker
        class="registration-list-filter"
        label="Data dostarczenia wniosku o wykreślenie"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.registrationIdTypeSentDate" name="registrationIdTypeSentDate"
      ></app-datepicker>

      <mat-form-field appearance="standard" class="registration-list-filter">
        <mat-label>Wysłany wniosek o wykreślenie </mat-label>
        <mat-select [(ngModel)]="initialFilters.registrationIdRequestForDeletionSent" name="registrationIdRequestForDeletionSent">
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <app-datepicker
        class="registration-list-filter"
        label="Data wysłania wniosku o wykreślenie "
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.registrationIdRequestForDeletionSentDate" name="registrationIdRequestForDeletionSentDate"
      ></app-datepicker>

      <mat-form-field appearance="standard" class="registration-list-filter">
        <mat-label>Zgoda na podwójną rejestrację  </mat-label>
        <mat-select [(ngModel)]="initialFilters.registrationIdConsentToDualRegistration" name="registrationIdConsentToDualRegistration">
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <app-datepicker
        class="registration-list-filter"
        label="Data uzyskania zgody na podwójną rejestrację"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.registrationIdConsentToDualRegistrationDate" name="registrationIdConsentToDualRegistrationDate"
      ></app-datepicker>

      <mat-form-field appearance="standard" class="registration-list-filter" >
        <mat-label>Wpis w KNF</mat-label>
        <mat-select [(ngModel)]="initialFilters.entryKnf" name="entryKnf">
          <mat-option [value]="null">Wszyscy</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="standard" class="registration-list-filter"  *ngIf="(insuranceCompanyId === 36 || insuranceCompanyId === 18) ">
        <mat-label>Przerejestrowanie Link4</mat-label>
        <mat-select [(ngModel)]="initialFilters.link4Reregistration" name="link4Reregistration">
          <mat-option [value]="null">Wszyscy</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="standard" class="registration-list-filter">
        <mat-label>Rejestracja Link4 + PZU ASF</mat-label>
        <mat-select [(ngModel)]="initialFilters.link4PzuAsfRegistration" name="link4PzuAsfRegistration">
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <app-dict
        [dictType]="'contract_type'"
        [label]="'Rodzaj umowy'" class="registration-list-filter"
        [(ngModel)]="initialFilters.contractType" name="contractType"
      ></app-dict>

      <app-dict
        [dictType]="'contract_status'"
        [label]="'Status umowy'" class="registration-list-filter"
        [(ngModel)]="initialFilters.contractStatus" name="contractStatus"
      ></app-dict>

    </ng-container>
  </form>

  <div *ngIf="deregistrationPackUuid">
    <button [disabled]="!(userPermissions | async).deregistration.delete " (click)="addRegistrationToPack()" mat-raised-button color="primary"><mat-icon>send_and_archive</mat-icon>  Dodaj do paczki</button>
  </div>


  <div *ngIf="!disableFilters" fxLayout="row" fxLayoutGap="15px">

    <span fxFlex></span>
    <div fxLayout="row" fxLayoutGap="15px">
      <button *ngIf="generalList() && (userPermissions | async).registration.read_report" (click)="downloadDoubleRegistrationReport()" [disabled]="!(userPermissions | async).registration.read_report || serchRegistration"
              mat-raised-button class="report-button">
        <mat-icon>download</mat-icon> Pobierz raport podwójnej rejestracji</button>
      <button  *ngIf="!generalList() && !customeRaportList() && (userPermissions | async).registration.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).registration.read_report || serchRegistration"
              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>

      <button  *ngIf="(insuranceCompanyId === 36 || insuranceCompanyId === 18) && (userPermissions | async).registration.read_report" (click)="downloadPzuForm()" [disabled]="!(userPermissions | async).registration.read_report || serchRegistration"
               mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz formatkę </span></button>

      <button  *ngIf="(generalList() || customeRaportList() )  && (userPermissions | async).registration.read_report" [disabled]="!(userPermissions | async).registration.read_report || serchRegistration"
              mat-raised-button [matMenuTriggerFor]="generate" class="report-button">
        <mat-icon>download</mat-icon> Pobierz raport</button>
      <mat-menu #generate="matMenu">
        <button *ngIf="(userPermissions | async).registration.read_report" [disabled]="!(userPermissions | async).registration.read_report"  mat-menu-item (click)="downloadReport()">Pobierz raport pełny</button>
        <button *ngIf="(userPermissions | async).registration.read_report" [disabled]="!(userPermissions | async).registration.read_report" mat-menu-item (click)="openReportDialog()">Pobierz raport niestandardowy</button>
        <button *ngIf="generalList()  && (userPermissions | async).registration.admin_root" [disabled]="!(userPermissions | async).registration.admin_root" mat-menu-item (click)="downloadVerificationReport()">Pobierz raport weryfikacji procesu</button>
        <button *ngIf="generalList()  && (userPermissions | async).registration.delete" [disabled]="!(userPermissions | async).registration.delete" mat-menu-item (click)="downloadPZuRegistrationReport()">Raport PZU</button>
      </mat-menu>
      <button  *ngIf="toBeBlocked() && (userPermissions | async).registration.read_report" (click)="downloadReportToBeBlocked()" [disabled]="!(userPermissions | async).registration.read_report || serchRegistration"
              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport rejestracji do zablokowania</span></button>
      <button [class.spinner]="serchRegistration" [disabled]="serchRegistration" (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
      <button  [disabled]=" serchRegistration" (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>
  </div>

  <table mat-table [dataSource]="registrations"  matSort (matSortChange)="sortChanged($event)">


    <ng-container matColumnDef="select"  >
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? toggleAllRows() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()"
                      [aria-label]="checkboxLabel()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="isSelect(row.uuid)"
          [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <!-- Position Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nazwa rejestracji</th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/rejestracje/szczegoly', element.uuid]">{{element.insuranceCompany.name}} {{element.ofwca.fullName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="ofwca">
      <th mat-header-cell *matHeaderCellDef> OFWCA </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca.uuid]">{{element.ofwca.fullName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="ofwcaLastName">
      <th mat-header-cell mat-sort-header="ofwcaLastName" *matHeaderCellDef> Nazwisko </th>
      <td mat-cell *matCellDef="let element">
        {{element.ofwca.lastName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="ofwca_just">
      <th mat-header-cell *matHeaderCellDef> OFWCA </th>
      <td mat-cell *matCellDef="let element">
        {{element.ofwca.fullName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="insuranceCompany">
      <th mat-header-cell *matHeaderCellDef> TU </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/tu/szczegoly', element.insuranceCompany.id]">{{element.insuranceCompany.name}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="insuranceCompany_just">
      <th mat-header-cell *matHeaderCellDef> TU </th>
      <td mat-cell *matCellDef="let element">
        {{element.insuranceCompany.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="insuranceCompanyType">
      <th mat-header-cell *matHeaderCellDef> Rodzaj </th>
      <td mat-cell *matCellDef="let element">
        {{element.insuranceCompany.type?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="passedExam100p">
      <th mat-header-cell *matHeaderCellDef> Zaświadczenie 100p </th>
      <td mat-cell *matCellDef="let element" class="center-cell">
        <ng-container *ngIf="element.insuranceCompany?.type?.key === INSURANCE_TYPE_ASSETS">
          <button *ngIf="element.ofwca?.hasPassedExam100pAssets" mat-icon-button><mat-icon class="positive-icon">check_circle</mat-icon></button>
          <button *ngIf="!element.ofwca?.hasPassedExam100pAssets" mat-icon-button><mat-icon class="negative-icon">cancel</mat-icon></button>
        </ng-container>
        <ng-container *ngIf="element.insuranceCompany?.type?.key === INSURANCE_TYPE_LIFE">
          <button *ngIf="element.ofwca?.hasPassedExam100pLife" mat-icon-button><mat-icon class="positive-icon">check_circle</mat-icon></button>
          <button *ngIf="!element.ofwca?.hasPassedExam100pLife" mat-icon-button><mat-icon class="negative-icon">cancel</mat-icon></button>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="passedExam40p">
      <th mat-header-cell *matHeaderCellDef> Zaświadczenie 40p </th>
      <td mat-cell *matCellDef="let element" class="center-cell">
        <button *ngIf="element.hasPassedExam40p" mat-icon-button><mat-icon class="positive-icon">check_circle</mat-icon></button>
        <button *ngIf="!element.hasPassedExam40p" mat-icon-button><mat-icon class="negative-icon">cancel</mat-icon></button>
      </td>
    </ng-container>

    <ng-container matColumnDef="statements">
      <th mat-header-cell *matHeaderCellDef> Oświadczenia komplet </th>
      <td mat-cell *matCellDef="let element" class="center-cell">
        <button *ngIf="element.statements" mat-icon-button><mat-icon class="positive-icon">check_circle</mat-icon></button>
        <button *ngIf="!element.statements" mat-icon-button><mat-icon class="negative-icon">cancel</mat-icon></button>
      </td>
    </ng-container>

    <ng-container matColumnDef="activeKrk">
      <th mat-header-cell *matHeaderCellDef> Aktywne KRK </th>
      <td mat-cell *matCellDef="let element" class="center-cell">
        <button *ngIf="element.ofwca?.hasActiveKrk" mat-icon-button><mat-icon class="positive-icon">check_circle</mat-icon></button>
        <button *ngIf="!element.ofwca?.hasActiveKrk" mat-icon-button><mat-icon class="negative-icon">cancel</mat-icon></button>
        <ng-container *ngIf="element.ofwca.hasActiveKrk">({{element.ofwca.krkActiveTo | daysDiff}}&nbsp;dni)</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="signedUpForAnExam">
      <th mat-header-cell *matHeaderCellDef> Zapisano na egzamin </th>
      <td mat-cell *matCellDef="let element" class="center-cell">
        <button *ngIf="SIGNED_UP_FOR_AN_EXAM.includes(element.status?.key)" mat-icon-button><mat-icon class="positive-icon">check_circle</mat-icon></button>
        <button *ngIf="!SIGNED_UP_FOR_AN_EXAM.includes(element.status?.key)" mat-icon-button><mat-icon class="negative-icon">cancel</mat-icon></button>
      </td>
    </ng-container>

    <ng-container matColumnDef="examPassed">
      <th mat-header-cell *matHeaderCellDef> Zdany egzamin </th>
      <td mat-cell *matCellDef="let element" class="center-cell">
        <button *ngIf="EXAM_PASSED.includes(element.status?.key)" mat-icon-button><mat-icon class="positive-icon">check_circle</mat-icon></button>
        <button *ngIf="!EXAM_PASSED.includes(element.status?.key)" mat-icon-button><mat-icon class="negative-icon">cancel</mat-icon></button>
      </td>
    </ng-container>

    <ng-container matColumnDef="sentToRegister">
      <th mat-header-cell *matHeaderCellDef> Wysłano do rejestracji </th>
      <td mat-cell *matCellDef="let element" class="center-cell">
        <button *ngIf="SENT_TO_REGISTER.includes(element.status?.key)" mat-icon-button><mat-icon class="positive-icon">check_circle</mat-icon></button>
        <button *ngIf="!SENT_TO_REGISTER.includes(element.status?.key)" mat-icon-button><mat-icon class="negative-icon">cancel</mat-icon></button>
      </td>
    </ng-container>

    <ng-container matColumnDef="agreedToDeregister">
      <th mat-header-cell *matHeaderCellDef> Zgoda ASF na wyrejestrowanie </th>
      <td mat-cell *matCellDef="let element" class="center-cell">
        <mat-slide-toggle
          [disabled]="!(userPermissions | async).registration.id_import || updateInProgress"
          [checked]="element.agreedToDeregister" (change)="agreedToDeregisterChanged(
            $event,
            element
        )"></mat-slide-toggle>
      </td>
    </ng-container>

    <ng-container matColumnDef="deregistrationPack">
      <th mat-header-cell *matHeaderCellDef> Paczka </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.deregistrationPack" class="default-link" [routerLink]="['/wyrejestrowania/szczegoly', element.deregistrationPack.uuid]">
          {{element.deregistrationPack.insuranceCompany.name}} {{element.deregistrationPack.createdAt | date:'y-MM-dd'}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="missingExam">
      <th mat-header-cell *matHeaderCellDef> Jaki egzamin potrzebny </th>
      <td mat-cell *matCellDef="let element">
        {{element.missingExam?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef> Firma </th>
      <td mat-cell *matCellDef="let element">
        {{element.contract?.company?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef> Partner </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.contract?.partner" class="default-link"
           [routerLink]="['/partnerzy/szczegoly', element.contract?.partner?.uuid]">{{element.contract?.partner?.shortName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="assetsRegional">
      <th mat-header-cell *matHeaderCellDef> Regionalny (majątek)</th>
      <td mat-cell *matCellDef="let element">
        {{element.assetsRegional?.fullName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="trainingRequirement">
      <th mat-header-cell *matHeaderCellDef> Wymóg szkoleniowy TU</th>
      <td mat-cell *matCellDef="let element">
        <ng-container>
          <label>Majątek</label>
          <b>
              {{(floor(element.insuranceCompany?.requiredAssetsMinutes / 60).toString() | number:'1.0-0') + 'h'}} {{(floor(element.insuranceCompany?.requiredAssetsMinutes % 60).toString() | number:'1.0-0') + 'min'}}
          </b>
          <br>
          <label>Życie</label>
          <b>
            {{(floor(element.insuranceCompany?.requiredLifeMinutes / 60).toString() | number:'1.0-0') + 'h'}} {{(floor(element.insuranceCompany?.requiredLifeMinutes % 60).toString() | number:'1.0-0') + 'min'}}
          </b>
          <br>
          <label>Ogólne</label>
          <b>
            {{(floor(element.insuranceCompany?.requiredGeneralMinutes / 60).toString() | number:'1.0-0') + 'h'}} {{(floor(element.insuranceCompany?.requiredGeneralMinutes % 60).toString() | number:'1.0-0') + 'min'}}
          </b>

        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="requirementMet">
      <th mat-header-cell *matHeaderCellDef> Wymóg IDD spełniony </th>
      <td mat-cell *matCellDef="let element" class="center-cell">
        <button *ngIf="element.requirementMet" mat-icon-button><mat-icon class="positive-icon">check_circle</mat-icon></button>
        <button *ngIf="!element.requirementMet" mat-icon-button><mat-icon class="negative-icon">cancel</mat-icon></button>
      </td>
    </ng-container>

    <ng-container matColumnDef="chronieDiscountCode">
      <th mat-header-cell *matHeaderCellDef> Kod zniżkowy </th>
      <td mat-cell *matCellDef="let element">
        {{element.ofwca.chronieDiscountCode}}
      </td>
    </ng-container>

    <ng-container matColumnDef="chronieLogin">
      <th mat-header-cell *matHeaderCellDef> Login </th>
      <td mat-cell *matCellDef="let element">
        {{element.ofwca.chronieLogin}}
      </td>
    </ng-container>

    <ng-container matColumnDef="rauNumberError">
      <th mat-header-cell *matHeaderCellDef>  </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.ofwca.rauNumbers.length !== 1">
          <button mat-icon-button class="negative-icon"><mat-icon>error</mat-icon></button>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="rauNumber">
      <th mat-header-cell *matHeaderCellDef> RAU </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.ofwca.rauNumbers.length === 0">
          <span class="negative-icon">(brak)</span>
        </ng-container>
        <ng-container *ngFor="let rau of element.ofwca.rauNumbers">
          {{rau.rau}}<br>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="sentToBlock">
      <th mat-header-cell *matHeaderCellDef> Wysłane do TU </th>
      <td mat-cell *matCellDef="let element">
        <mat-slide-toggle
          [disabled]="!(userPermissions | async).registration.write || updateInProgress"
          [checked]="element.sentToBlock" (change)="formChanged(
            $event,
            element,
            {sentToBlock: $event.checked, blocked: element.blocked}
        )"></mat-slide-toggle>
      </td>
    </ng-container>

    <ng-container matColumnDef="sentToPzuForVerification">
      <th mat-header-cell *matHeaderCellDef> Wysłano do weryfikacji PZU  </th>
      <td mat-cell *matCellDef="let element">
        <mat-slide-toggle
          [disabled]="!(userPermissions | async).registration.delete || updateInProgress"
          [checked]="element.sentToPzuForVerification" (change)="pzuChanged(
            $event,
            element,
            {sentToPzuForVerification: $event.checked,
            pzuVerificationSupplement: element.pzuVerificationSupplement,
           agreedToRegisterInPzu: element.agreedToRegisterInPzu}
        )"></mat-slide-toggle>
      </td>
    </ng-container>

    <ng-container matColumnDef="pzuVerificationSupplement">
      <th mat-header-cell *matHeaderCellDef> Dodatkowa weryfikacja PZU </th>
      <td mat-cell *matCellDef="let element">
        <mat-slide-toggle
          [disabled]="!(userPermissions | async).registration.delete || updateInProgress"
          [checked]="element.pzuVerificationSupplement" (change)="pzuChanged(
            $event,
            element,
            {sentToPzuForVerification: element.sentToPzuForVerification,
            pzuVerificationSupplement: $event.checked,
           agreedToRegisterInPzu: element.agreedToRegisterInPzu}
        )"></mat-slide-toggle>
      </td>
    </ng-container>

    <ng-container matColumnDef="agreedToRegisterInPzu">
      <th mat-header-cell *matHeaderCellDef> Zgoda na rejestrację PZU </th>
      <td mat-cell *matCellDef="let element">
        <mat-slide-toggle
          [disabled]="!(userPermissions | async).registration.delete || updateInProgress"
          [checked]="element.agreedToRegisterInPzu" (change)="pzuChanged(
            $event,
            element,
            {sentToPzuForVerification: element.sentToPzuForVerification,
            pzuVerificationSupplement: element.pzuVerificationSupplement,
           agreedToRegisterInPzu:$event.checked}
        )"></mat-slide-toggle>
      </td>
    </ng-container>

    <ng-container matColumnDef="blocked">
      <th mat-header-cell *matHeaderCellDef> Zablokowane </th>
      <td mat-cell *matCellDef="let element">
        <mat-slide-toggle
          [disabled]="!(userPermissions | async).registration.write || updateInProgress || !element.sentToBlock"
          [checked]="element.blocked" (change)="formChanged(
            $event,
            element,
            {sentToBlock: element.sentToBlock, blocked: $event.checked}
        )"></mat-slide-toggle>
      </td>
    </ng-container>

    <ng-container matColumnDef="chronieAccess">
      <th mat-header-cell *matHeaderCellDef> Dostęp Chronie.pl</th>
      <td mat-cell *matCellDef="let element">
        {{element.hasChronieAccess ? 'Tak' : 'Nie'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="dateOfRegistrationForTheExam">
      <th mat-header-cell *matHeaderCellDef> Data zapisania na egzamin </th>
      <td mat-cell *matCellDef="let element">
        {{element?.dateOfRegistrationForTheExam | date:'y-MM-dd'}}
      </td>
    </ng-container>


    <ng-container matColumnDef="dateOfStartTheExam">
      <th mat-header-cell *matHeaderCellDef> Data rozpoczęcia egzaminu </th>
      <td mat-cell *matCellDef="let element">
        {{element?.meeting?.startsAt | date:'y-MM-dd HH:mm'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="statusExam">
      <th mat-header-cell *matHeaderCellDef> Status egzaminu</th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="element.meeting" mat-raised-button [ngClass]="element.status.color + '-button'">{{element?.meeting?.status?.name}}</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="examType">
      <th mat-header-cell *matHeaderCellDef> Rodzaj egzaminu </th>
      <td mat-cell *matCellDef="let element">
        {{element?.meeting?.examType?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="contractActiveTo">
      <th mat-header-cell *matHeaderCellDef> Data zakończenia umowy </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.contract?.activeTo">
          <a class="default-link" [routerLink]="['/umowy/szczegoly', element.contract.uuid]">
            {{element.contract?.activeTo | date:'y-MM-dd'}}
          </a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>expand_more</mat-icon></button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button [disabled]="!(userPermissions | async).meeting.read_and_sign_up" mat-menu-item (click)="registerToExam(element)">Zapisz na egzamin</button>
          <button [disabled]="!(userPermissions | async).registration.read" mat-menu-item (click)="generateAuthorization(element)">Wygeneruj upoważnienie</button>
          <button *ngIf="showAddToPackAction" [disabled]="!(userPermissions | async).deregistration.write || !element.agreedToDeregister" mat-menu-item (click)="addToDeregistrationPack(element)">Dodaj do paczki</button>
          <button *ngIf="!deregistrationPackObject" [disabled]="!(userPermissions | async).registration.delete" mat-menu-item (click)="deleteRegistration(element)">Usuń</button>
          <button *ngIf="deregistrationPackObject" [disabled]="!(userPermissions | async).deregistration.write && deregistrationPackObject.status.key === REGISTRATION_STATUS_TO_DEREGISTER" mat-menu-item (click)="deleteFromDeregistrationPack(element)">Usuń z paczki</button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator #paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
